import { Page, PageTitle } from "@/components/page"
import { CRUDLoader } from "@/components/page/crudloader"
import { CRUDToolbar } from "@/components/page/crudtoolbar"
import { usePage } from "@/components/page/hooks"
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form"
import { Textarea } from "@/components/ui/textarea"
import { databricks } from "@/lib/agents/search/databricks"
import { app } from "@/lib/app"
import { zodResolver } from "@hookform/resolvers/zod"
import { BookCopy } from "lucide-react"
import { useEffect, useState } from "react"
import { useForm } from "react-hook-form"
import { toast } from "sonner"
import { estimateTokenCount } from "tokenx"
import { z } from "zod"

type Vector = Table<"vectors">

export const dabrickscrud = {
  title: "Vector",
  description: "Manage your organization's Documents.",
  route: "/docu/databricks/:id",
  icon: BookCopy,
  component,
  group: "docs",
  resource: "collections",
  action: "read",
} satisfies PageConfig

const FormSchema = z.object({
  text: z.string().optional().nullable(),
})

type FormData = z.infer<typeof FormSchema>

export function component() {

  const [data, setData] = useState<DatabricksTable | null>({})
  const [loading, setLoading] = useState(true)

  const { team, navigate, id } = usePage()

  async function loadItem() {
    const apikeys = await app.fetchAPIkeys(team?.id)
    const item = await databricks.find({ id, token: apikeys.databricks })
    console.log(item)
    setData(item)
    setLoading(false)
  }

  useEffect(() => {
    if (team) {
      loadItem()
    }
  }, [team])


  const form = useForm<FormData>({
    resolver: zodResolver(FormSchema),
    defaultValues: data as any,
    values: data as any,
  })

  async function onSubmit(data: DatabricksTable) {
    console.log("Submit: ", data)
    setLoading(true)
    const apikeys = await app.fetchAPIkeys(team?.id)
    if (!apikeys || !apikeys.databricks) {
      toast.error("Databricks API key not found")
      return
    }
    const tokens = estimateTokenCount(data.text)
    await databricks.update({
      token: apikeys.databricks,
      id: id,
      content: data.text,
      tokens,
    })
    await databricks.sync({ token: apikeys.databricks })
    toast.success("Data saved")
    navigate("/docu/databricks")
  }

  if (loading) return <CRUDLoader />

  console.log(data)


  return <Page>
    <div className="pb-8">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit as any)}>
          <PageTitle>
            <CRUDToolbar table="vectors" onSuccess={"/docu/databricks"} />
          </PageTitle>
          <h2 className="my-4">{"Name: "} {data.file_type} </h2>
          <div className="rgrid">
            <div className="row">
              <div className="rc-12">
                <FormField control={form.control} name="text" render={({ field }) => (
                  <FormItem>
                    <FormLabel>Content</FormLabel>
                    <FormControl><Textarea {...field} value={field.value || ""} rows={20} className="font-mono text-sm" /></FormControl>
                    <FormMessage />
                  </FormItem>
                )} />
              </div>
            </div>
          </div>
        </form>
      </Form>
    </div>
  </Page>
}
